module.exports = __webpack_public_path__ + "img/Cheer Megaphone00.ab3147ec.jpg";